module.exports = __webpack_public_path__ + "media/images/iconSocialLink__accent-b5cfa7ca0b62fccd9768eaf60f565c2b.png";